module.exports = __webpack_public_path__ + "img/weddings_12_V.9a766212.webp";